export const APP_CONFIGS = 'APP_CONFIGS'
